import {
	MODULE_NAME,
	INTEGRATION,
	INTEGRATIONS,
	RELOAD_INTEGRATIONS,
	SAVE_INTEGRATION,
	SET_INTEGRATIONS,
	SHOW_MODAL_INTEGRATION,
	SET_INTEGRATION,
	SITEBOD,
	SITEBODS,
	RELOAD_SITEBODS,
	REMOVE_SITEBOD,
	SET_SITEBODS,
	SAVE_SITEBOD,
	SHOW_MODAL_SITEBOD,
	SET_SITEBOD,
	THIRD_PARTIES,
	THIRD_PARTY,
	RELOAD_THIRD_PARTIES,
	SET_LAST_THIRD_PARTYID,
	SET_THIRD_PARTIES,
	CLEAR_THIRD_PARTIES,
	SET_THIRD_PARTY,
	SAVE_THIRD_PARTY,
	SHOW_MODAL_THIRDPARTY,
	VERSIONS,
	SET_VERSIONS,
	SET_VERSION_ITEMS,
	CLEAR_VERSION_ITEMS,
	UPDATE_VERSIONS,
	REFERENCE_ID
} from './integrations-mutation-types';
import { TOAST_MESSAGES_PUSH } from '@/store/modules/mutation-types';
import { ApiService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';
import { mergePayloadObjects } from '@/utils/object';

// libraries
import _ from 'lodash';

const baseApi = `/${MODULE_NAME}/`;

const setToastMessage = 'toastMessages/push';
let messageObj = {
	statusCode: 400,
	message: 'An error occurred. Please try again.'
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_NAME,
	namespaced: true,
	state: {
		[INTEGRATION]: null,
		[INTEGRATIONS]: {},
		[RELOAD_INTEGRATIONS]: false,
		[SHOW_MODAL_INTEGRATION]: false,

		[SITEBOD]: null,
		[SITEBODS]: {},
		[RELOAD_SITEBODS]: false,
		[SHOW_MODAL_SITEBOD]: false,

		[SHOW_MODAL_THIRDPARTY]: false,
		[RELOAD_THIRD_PARTIES]: false,
		[THIRD_PARTIES]: {},
		[THIRD_PARTY]: {},

		[VERSIONS]: {},
		versionItems: [],
		[REFERENCE_ID]: null
	},
	mutations: {
		//integrations
		[RELOAD_INTEGRATIONS](state, value) {
			state[RELOAD_INTEGRATIONS] = value;
		},
		[SET_INTEGRATIONS](state, obj) {
			state[INTEGRATIONS] = obj;
		},
		[SHOW_MODAL_INTEGRATION](state, value) {
			state[SHOW_MODAL_INTEGRATION] = value;
		},
		[SET_INTEGRATION](state, obj) {
			state[INTEGRATION] = obj;
		},
		SetReferenceId(state, value) {
			state[REFERENCE_ID] = value;
		},

		//site bods
		[RELOAD_SITEBODS](state, value) {
			state[RELOAD_SITEBODS] = value;
		},
		[REMOVE_SITEBOD](state, id) {
			const index = state[SITEBODS].items.findIndex(x => x.id === id);

			if (index >= 0) {
				state[SITEBODS].items.splice(index, 1);
			}
		},
		[SET_SITEBODS](state, obj) {
			state[SITEBODS] = obj;
		},
		[SHOW_MODAL_SITEBOD](state, value) {
			state[SHOW_MODAL_SITEBOD] = value;
		},
		[SET_SITEBOD](state, obj) {
			state[SITEBOD] = obj;
		},

		//third parties
		[RELOAD_THIRD_PARTIES](state, value) {
			state[RELOAD_THIRD_PARTIES] = value;
		},
		[SET_THIRD_PARTIES](state, obj) {
			state[THIRD_PARTIES] = obj;
		},
		[CLEAR_THIRD_PARTIES](state) {
			state.thirdparties = {};
		},
		[SET_THIRD_PARTY](state, obj) {
			state[THIRD_PARTY] = obj;
			state[SHOW_MODAL_THIRDPARTY] = obj !== null;
		},
		[SHOW_MODAL_THIRDPARTY](state, value) {
			state[SHOW_MODAL_THIRDPARTY] = value;
		},

		//versions
		[SET_VERSIONS](state, obj) {
			state[VERSIONS] = obj;
		},
		[SET_VERSION_ITEMS](state, items) {
			items.forEach(item => {
				state.versionItems.push({
					text: item.bodType,
					value: item.bodType
				});
			});
		},
		[CLEAR_VERSION_ITEMS](state) {
			state.versionItems = [];
		},
		[UPDATE_VERSIONS](state, obj) {
			state[VERSIONS].items.push(obj);
		}
	},
	actions: {
		//integrations
		[SET_INTEGRATION]({ commit }, obj) {
			commit(SET_INTEGRATION, obj);
			commit(SHOW_MODAL_INTEGRATION, obj !== null);
		},
		[SHOW_MODAL_INTEGRATION]({ commit }, value) {
			if (!value) {
				commit('SetReferenceId', null);
			}
			commit(SHOW_MODAL_INTEGRATION, value);
		},
		SetReferenceId({ commit }, value) {
			commit('SetReferenceId', value);
		},
		async [SAVE_INTEGRATION]({ dispatch, commit, state }, obj) {
			let action = 'added';
			const parseResponse = () => {
				messageObj = {
					statusCode: 200,
					message: `Integration successfully ${action}.`
				};
				dispatch(SET_INTEGRATION, null);
				commit(RELOAD_INTEGRATIONS, true);
			};
			let result;
			if (obj.id) {
				action = 'edited';
				result = await api
					.put(
						`${baseApi}${INTEGRATIONS}/${obj.id}/${obj.dcsIntegrationTypesId}/${obj.partyId}`,
						obj
					)
					.then(res => {
						parseResponse(res);
					})
					.catch()
					.finally(() => {
						dispatch(setToastMessage, messageObj, { root: true });
					});
			} else {
				obj.referenceId = state[REFERENCE_ID];
				result = await api
					.post(
						`${baseApi}${INTEGRATIONS}/${obj.dcsIntegrationTypesId}/${obj.partyId}`,
						obj
					)
					.then(res => {
						parseResponse(res);
					})
					.catch(err => {
						if (err) {
							messageObj.message = err;
						}
					})
					.finally(() => {
						commit('SetReferenceId', null);
						dispatch(setToastMessage, messageObj, { root: true });
					});
			}
			return result;
		},
		async [SET_INTEGRATIONS]({ dispatch, commit, state }, params) {
			const { page } = params;
			if (page === 1) {
				commit(SET_INTEGRATIONS, {});
			}
			await api
				.get(buildRoute(`${baseApi}${INTEGRATIONS}`, params))
				.then(res => {
					if (_.isEmpty(state[INTEGRATIONS])) {
						commit(SET_INTEGRATIONS, res);
					} else {
						let currentStore = _.cloneDeep(state[INTEGRATIONS]);
						let integrationsPayload = mergePayloadObjects(
							currentStore,
							res
						);
						commit(SET_INTEGRATIONS, integrationsPayload);
					}
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					}
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});

			commit(RELOAD_INTEGRATIONS, false);
		},

		//site bods
		[SET_SITEBOD]({ commit }, obj) {
			commit(SET_SITEBOD, obj);
			commit(SHOW_MODAL_SITEBOD, obj !== null);
		},
		[SHOW_MODAL_SITEBOD]({ commit }, value) {
			commit(SHOW_MODAL_SITEBOD, value);
		},
		async [SET_SITEBODS]({ dispatch, commit, state }, params) {
			const { page } = params;
			if (page === 1) {
				commit(SET_SITEBODS, {});
			}
			await api
				.get(buildRoute(`${baseApi}${SITEBODS}`, params))
				.then(res => {
					if (_.isEmpty(state[SITEBODS])) {
						commit(SET_SITEBODS, res);
					} else {
						let currentStore = _.cloneDeep(state[SITEBODS]);
						let siteBodsPayload = mergePayloadObjects(
							currentStore,
							res
						);
						commit(SET_SITEBODS, siteBodsPayload);
					}
				})
				.catch(err => {
					dispatch(
						TOAST_MESSAGES_PUSH,
						{
							statusCode: 400,
							message: err
						},
						{
							root: true
						}
					);
				});

			commit(RELOAD_SITEBODS, false);
		},
		async [REMOVE_SITEBOD]({ commit, dispatch }, obj) {
			await api
				.delete(buildRoute(`${baseApi}${SITEBODS}/${obj.id}`, {}))
				.then(() => {
					commit(REMOVE_SITEBOD, obj.id);
					messageObj = {
						statusCode: 200,
						message: 'SiteBod was successfully removed'
					};
				})
				.catch(err => {
					if (err) {
						messageObj.message = err;
					}
				})
				.finally(() => {
					return dispatch('showToastMessage', messageObj);
				});
		},
		async [SAVE_SITEBOD]({ dispatch, commit }, obj) {
			let action = 'added';
			const parseResponse = res => {
				commit(UPDATE_VERSIONS, {
					active: true,
					bodType: res.bodType,
					bodVersion: res.bodVersion
				});
				messageObj = {
					statusCode: 200,
					message: `SiteBod successfully ${action}.`
				};
				dispatch(SET_SITEBOD, null);
				commit(RELOAD_SITEBODS, true);
			};
			let result;
			if (obj.id) {
				action = 'edited';
				result = await api
					.put(`${baseApi}${SITEBODS}/${obj.id}`, obj)
					.then(res => {
						parseResponse(res);
					})
					.catch(err => {
						if (err) {
							messageObj.message = err;
						}
					})
					.finally(() => {
						dispatch(setToastMessage, messageObj, { root: true });
					});
			} else {
				result = await api
					.post(`${baseApi}${SITEBODS}`, obj)
					.then(res => {
						parseResponse(res);
					})
					.catch(err => {
						if (err) {
							messageObj.message = err;
						}
					})
					.finally(() => {
						dispatch(setToastMessage, messageObj, { root: true });
					});
			}

			return result;
		},

		//thirdparties
		[SET_THIRD_PARTY]({ commit }, obj) {
			commit(SET_THIRD_PARTY, obj);
			commit(SHOW_MODAL_THIRDPARTY, obj !== null);
		},
		[SHOW_MODAL_THIRDPARTY]({ commit }, value) {
			commit(SHOW_MODAL_THIRDPARTY, value);
		},
		async [SAVE_THIRD_PARTY]({ dispatch, commit }, obj) {
			let action = 'added';
			const parseResponse = () => {
				messageObj = {
					statusCode: 200,
					message: `ThirdParty successfully ${action}.`
				};
				dispatch(SET_THIRD_PARTY, null);
				commit(RELOAD_THIRD_PARTIES, true);
			};
			let result;
			if (obj.id) {
				action = 'edited';
				result = await api
					.put(`${baseApi}${THIRD_PARTIES}/${obj.id}`, obj)
					.then(res => {
						parseResponse(res);
					})
					.catch(err => {
						if (err) {
							messageObj.message = err;
						}
					})
					.finally(() => {
						dispatch(setToastMessage, messageObj, { root: true });
					});
			} else {
				result = await api
					.post(`${baseApi}${THIRD_PARTIES}`, obj)
					.then(res => {
						parseResponse(res);
					})
					.catch(err => {
						if (err) {
							messageObj.message = err;
						}
					})
					.finally(() => {
						dispatch(setToastMessage, messageObj, { root: true });
					});
			}

			return result;
		},
		async [SET_THIRD_PARTIES]({ commit }, params) {
			commit(SET_THIRD_PARTIES, {});

			const results = await api.get(
				buildRoute(`${baseApi}${THIRD_PARTIES}`, params)
			);

			commit(SET_THIRD_PARTIES, results);
			commit(RELOAD_THIRD_PARTIES, false);
		},
		async getThirdParties({ dispatch, commit, state }, parameters) {
			let params = _.cloneDeep(parameters);

			const valuesToRemove = [undefined, '', 'all'];
			params = _.omitBy(params, value => valuesToRemove.includes(value));

			const { page } = params;
			if (page === 1) {
				commit(CLEAR_THIRD_PARTIES);
			}

			return new Promise((resolve, reject) => {
				api.get('/integrations/thirdparties', {
					params
				})
					.then(res => {
						if (_.isEmpty(state[THIRD_PARTIES])) {
							commit(SET_THIRD_PARTIES, res);
						} else {
							let currentStore = _.cloneDeep(
								state[THIRD_PARTIES]
							);
							let thirdpartiesPayload = mergePayloadObjects(
								currentStore,
								res
							);
							commit(SET_THIRD_PARTIES, thirdpartiesPayload);
						}
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async getThirdPartyById({ dispatch, commit }, id) {
			let result = {};
			await api
				.get(`/integrations/thirdparties/${id}`)
				.then(res => {
					result = res;
					commit(SET_THIRD_PARTY, result);
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					} else {
						messageObj.message = 'ThirdParty not found';
					}
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});

			return result;
		},
		async [SET_LAST_THIRD_PARTYID]() {
			return await api
				.get(`${baseApi}${THIRD_PARTIES}/lastpartyid`)
				.then(resp => {
					return resp;
				})
				.catch(err => {
					if (err) {
						messageObj.message = err;
					}
				});
		},

		//versions
		async [SET_VERSIONS]({ commit }, params) {
			const results = await api.get(
				buildRoute(`${baseApi}${VERSIONS}`, params)
			);
			commit(SET_VERSIONS, results);
		},

		async getVersionItems({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				commit(CLEAR_VERSION_ITEMS);

				api.get('/integrations/versions')
					.then(res => {
						commit(SET_VERSION_ITEMS, res.items);
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		showToastMessage({ dispatch }, message) {
			dispatch(setToastMessage, message, { root: true });

			return message.statusCode === 200;
		}
	},
	getters: {
		[INTEGRATION]: state => state[INTEGRATION],
		[INTEGRATIONS]: state => state[INTEGRATIONS],
		[RELOAD_INTEGRATIONS]: state => state[RELOAD_INTEGRATIONS],
		[SHOW_MODAL_INTEGRATION]: state => state[SHOW_MODAL_INTEGRATION],
		[REFERENCE_ID]: state => state[REFERENCE_ID],

		[RELOAD_SITEBODS]: state => state[RELOAD_SITEBODS],
		[SHOW_MODAL_SITEBOD]: state => state[SHOW_MODAL_SITEBOD],
		[SITEBOD]: state => state[SITEBOD],
		[SITEBODS]: state => state[SITEBODS],

		[RELOAD_THIRD_PARTIES]: state => state[RELOAD_THIRD_PARTIES],
		[SHOW_MODAL_THIRDPARTY]: state => state[SHOW_MODAL_THIRDPARTY],
		[THIRD_PARTY]: state => state[THIRD_PARTY],
		[THIRD_PARTIES]: state => state[THIRD_PARTIES],
		thirdPartiesById: state => id => {
			if (!state.thirdparties.items) {
				return {};
			}

			return state.thirdparties.items.find(
				item => item.thirdPartyId === id
			);
		},

		[VERSIONS]: state => state[VERSIONS]
	}
};
